<template>
	<div>
		<div class="modal fade" id="CatModal" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<!--
				=================================================================================================================
													  MAIN/EXAM CREATION MODAL!
				=================================================================================================================
			-->

				<div
					style="width: 60%; margin: 0 auto"
					class="modal-content"
					v-if="
						!this.data.creationCPF &&
						!this.data.creationShip &&
						!this.data.creationPassaport &&
						!this.data.creationType
					"
				>
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							EDITAR COLABORADOR
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>CPF</span>
							<div class="add-more-section">
								<input
									type="text"
									v-model="data.CPF"
									class="form-control"
									v-on:change="handleChangeCPF()"
									ref="cpf"
									id="cpf"
									v-mask="'###.###.###-##'"
								/>
								<aBtn
									@click="handleToggleCreationCPF()"
									text=""
									icon="plus"
									size="sm"
									type="success"
								/>
							</div>
						</div>

						<div class="col-sm-6">
							<span>NOME</span>
							<input
								readonly
								type="text"
								v-model="data.nome"
								class="form-control"
							/>
						</div>

						<div class="col-sm-3">
							<span>NAVIO</span>
							<div class="add-more-section">
								<select
									v-model="data.navio"
									class="form-control"
								>
									<option
										v-for="(navio, index) in this.navios"
										:key="index"
										:value="navio.navio"
									>
										{{ navio.navio }}
									</option>
								</select>
							</div>
						</div>

						<div class="clearfix"></div>
						<br />
						<!-- <pre>{{data}}</pre> -->
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								data-dismiss="modal"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>
							<aBtn
								action="private-save-vacinas"
								@click="save"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>

				<!--
				=================================================================================================================
													CREATE COLABORATOR MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" v-if="this.data.creationCPF">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE VACINAS
						</h4>
					</div>
					<!-- <div class="modal-body" v-if="!this.data.creationCPF"> -->
					<div class="modal-body">
						<div class="col-sm-4">
							<span>CPF</span>
							<input
								class="form-control"
								type="text"
								v-model="data.CPF"
								v-on:change="handleChangeCPF()"
								ref="cpf"
								id="cpf"
								v-mask="'###.###.###-##'"
							/>
						</div>

						<div class="col-sm-8">
							<span>NOME</span>
							<input
								class="form-control"
								type="text"
								v-model="data.nome"
								ref="nome"
								id="nome"
							/>
						</div>

						<div class="col-sm-6">
							<span>RG/PASSAPORTE</span>
							<input
								class="form-control"
								type="number"
								v-model="data.RG"
								ref="rg"
								id="rg"
							/>
						</div>

						<div class="col-sm-3">
							<span>Cargo</span>
							<select v-model="data.cargos" class="form-control">
								<option
									v-for="(cargo, index) in cargos"
									:key="index"
									:value="cargo.nome_cargo"
								>
									{{ cargo.nome_cargo }}
								</option>
							</select>
						</div>

						<div class="col-sm-3">
							<span>NAVIO</span>
							<div class="add-more-section">
								<select
									v-model="data.navio"
									class="form-control"
								>
									<option
										v-for="(navio, index) in this.navios"
										:key="index"
										:value="navio.navio"
									>
										{{ navio.navio }}
									</option>
								</select>
							</div>
						</div>

						<div class="col-sm-5">
							<span>Empresa</span>
							<select v-model="data.empresa" class="form-control">
								<option
									v-for="(empresa, index) in empresas"
									:key="index"
									:value="empresa.razao_social"
								>
									{{ empresa.razao_social }}
								</option>
							</select>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								@click="handleToggleCreationCPF()"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-vacinas"
								@click="saveCpf"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>

				<!--
				=================================================================================================================
														CREATE SHIP MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" v-if="this.data.creationShip">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE VACINAS
						</h4>
					</div>
					<!-- <div class="modal-body" v-if="!this.data.creationCPF"> -->
					<div class="modal-body">
						<div class="col-sm-12">
							<span>EMPRESA</span>
							<input
								type="text"
								v-model="data.empresa"
								class="form-control"
							/>
						</div>

						<div class="col-sm-2">
							<span>FROTA</span>
							<input
								type="text"
								v-model="data.frota"
								class="form-control"
							/>
						</div>

						<div class="col-sm-10">
							<span>NAVIO</span>
							<input
								type="text"
								v-model="data.navio"
								class="form-control"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								@click="handleToggleCreationShip()"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-vacinas"
								@click="saveShip"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>

				<!--
				=================================================================================================================
													CREATE TYPE OF EXAM MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" v-if="this.data.creationType">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE VACINAS
						</h4>
					</div>
					<!-- <div class="modal-body" v-if="!this.data.creationCPF"> -->
					<div class="modal-body">
						<div class="col-sm-12">
							<span>Nome</span>
							<input
								type="text"
								v-model="data.nomeTipo"
								class="form-control"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								@click="handleToggleCreationType()"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-vacinas"
								@click="saveType"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>

				<!--
				=================================================================================================================
													CREATE PASSAPORT MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" v-if="this.data.creationPassaport">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE VACINAS
						</h4>
					</div>
					<!-- <div class="modal-body" v-if="!this.data.creationCPF"> -->
					<div class="modal-body">
						<div class="col-sm-12">
							<span>Nome</span>
							<input
								type="text"
								v-model="data.nome"
								class="form-control"
							/>
						</div>

						<div class="col-sm-12">
							<span>PASSAPORT</span>
							<input
								type="text"
								v-model="data.passaport"
								class="form-control"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								@click="handleToggleCreationPassaport()"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-vacinas"
								@click="savePassaport"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

	id precisa existir para poder ocorrer a criação

	*/
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';
	import moment from 'moment';
	import { mask } from 'vue-the-mask';
	// md-autocomplete MdAutocomplete
	import { MdAutocomplete } from 'vue-material/dist/components';

	let reset = {
		empresa: '',
		nome_vacina: '',
		colaborador: '',
		cargo: '',
		navio: '',
		frota: '',
		idade: 0,

		status: '',

		statusMask: "'##%'",

		data_vacina: ``,
		dataEnviada: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,
		vencimento_vacina: ``,
		validade: '',
		marca: '',
		creationCPF: false,
		creationShip: false,
		creationType: false,
		creationPassaport: false,
		municipio: '',
		estado: '',
		RG: '',
		CPF: '',
		passaport: '',
		control: '',
		CPFControl: '',
		tipo_vacina: '',
	};

	export default {
		name: 'ChModalVacinas',
		components: { aBox, aBtn, mask },
		data() {
			return {
				data: {
					moment: moment,
					...clone(reset),
				},
				test: null,
				pessoas: [],

				cargos: [
					{
						navio: 'Não há dados',
					},
				],

				estados: null,
				municipios: null,
				tipo_vacina: [
					{
						nomeTipo: '1',
						status: 25,
					},
					{
						nomeTipo: '2',
						status: 50,
					},
					{
						nomeTipo: '3',
						status: 75,
					},
					{
						nomeTipo: 'DOSE DE REFORÇO',
						status: 100,
					},
				],

				laboratory: [
					'ABBOTT',
					'CONTRAPROVA',
					'HECIN',
					'HEMOCLIN',
					'HI LAB',
					'LABORLIFE',
					'TOMMASI',
					'ALIANCA',
				],

				parca: ['HEMOCLIN', 'SOLANA', 'VIAMED', 'TOMMASI'],
			};
		},
		methods: {
			format(value, event) {
				return moment(value).format('YYYY-MM-DD');
			},

			handleConvertStringToDateTime(stringValue) {
				console.log(stringValue);
				console.log(
					moment(stringValue, 'DD/MM/YYYY HH:mm').format(
						'YYYY-MM-DD HH:mm:00'
					)
				);
				return moment(stringValue, 'DD/MM/YYYY HH:mm').format(
					'YYYY-MM-DD HH:mm:00'
				);
			},

			handleParseDateTimeToString(dateTimeValue) {
				return moment(dateTimeValue, 'YYYY-MM-DD HH:mm:00').format(
					'DD/MM/YYYY HH:mm'
				);
			},

			handleChangeStatus(statusStr) {},

			handleChangeDataFormat(e, dateModel) {
				const stringValue = e.target.value;
				// data: "2022-08-03 14:00:00"

				console.log(stringValue);
				const dateStringParsed =
					this.handleConvertStringToDateTime(stringValue);
				//2014-02-27T10:00:00

				console.log(dateStringParsed);

				this.data[dateModel] = dateStringParsed;
			},

			onSelectCargo(val) {
				this.cargo = val.nome_cargo;
				console.log(val);
			},

			onSelectLaboratorio(val) {
				this.cargo = val.nome_cargo;
				console.log(val);
			},

			onSelectTipoVacina(val) {
				const valueSelected = val.target.value;

				let percentage = 0;

				this.tipo_vacina.map((teste) => {
					if (teste.nomeTipo == valueSelected)
						percentage = teste.status;
				});

				this.data.tipo_vacina = valueSelected;
				this.data.status_vacina = percentage;
			},

			handleChangeCPF() {
				const cpf = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				if (cpf.length < 9) return;

				const testParms = {
					pager: {
						page: '0',
						qnt: '999',
					},
					filter: `cpf=${cpf}`,
				};

				WBS.send('private-read-pessoas', testParms, (resp) => {
					if (!resp.data.table[0]) {
						return toastr.error('CPF não cadastrado');
						// toastr.error(resp.msgs[0])
					}

					const tableValues = resp.data.table[0];

					this.data.empresa = tableValues.empresa;
					this.data.nome = tableValues.nome; //colaborador
					this.data.RG = tableValues.RG;
					this.data.cargo = tableValues.cargo;
				});
			},

			handleChangePassaport() {
				const passaport = String(this.data.passaport).replace(
					/[^\w\s]/gi,
					''
				);
				// const passaport = this.data.passaport
				if (passaport.length < 2) return;

				const testParms = {
					pager: {
						page: '0',
						qnt: '999',
					},
					filter: `passaport=${passaport}`,
				};

				WBS.send('private-read-passaport', testParms, (resp) => {
					if (!resp.data.table[0]) {
						return toastr.error('Passaporte não cadastrado');
						// toastr.error(resp.msgs[0])
					}

					const tableValues = resp.data.table[0];

					this.data.empresa = tableValues.empresa;
					this.data.nome = tableValues.nome; //colaborador
					this.data.RG = tableValues.RG;
					this.data.cargo = tableValues.cargo;
				});
			},

			handleToggleCreationCPF() {
				this.data.creationCPF = !this.data.creationCPF;
			},

			handleToggleCreationShip() {
				this.data.creationShip = !this.data.creationShip;
			},

			handleToggleCreationType() {
				this.data.creationType = !this.data.creationType;
			},

			handleToggleCreationPassaport() {
				this.data.creationPassaport = !this.data.creationPassaport;
			},

			open(data = null) {
				if (data != null) {
					// console.log(String(data.CPF).replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/g, "$1.$2.$3-$4"))

					console.log('data');
					console.log(data);

					data.vencimento_vacina = this.handleParseDateTimeToString(
						data.vencimento_vacina
					);
					data.CPFControl = data.CPF;

					this.data = clone(data);
				} else this.data = clone(reset);
				$('#CatModal').modal('show');
			},

			save() {
				this.data.CPF = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				this.data.control = `${this.data.CPF} ${this.data.data}`;

				WBS.send(
					'private-custom-vacinasUpdateCpf',
					this.data,
					(resp) => {
						if (resp.status == 'success') {
							toastr.success('Registro alterado com sucesso!');
							this.$emit('update');
							$('#CatModal').modal('hide');
						} else {
							toastr.error(resp.msgs[0]);
							console.log(resp);
							console.log(this.data);
						}
					}
				);
			},

			saveCpf() {
				this.data.CPF = String(this.data.CPF).replace(/[^\w\s]/gi, '');

				WBS.send('private-save-pessoas', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationCPF();
						// $('#CatModal').modal('hide')
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});

				console.log('submit ----------*-------------');
			},

			handleLoadNavios() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-navios', testParms, (resp) => {
					const unorderednavios = resp.data.table;
					this.navios = unorderednavios.sort((a, b) =>
						a.navio.localeCompare(b.navio)
					); //order the object alphabetically

					if (this.navios.length - 1 > 0) {
						const lastNavio = this.navios[this.navios.length - 1];
						this.data.navio = lastNavio.navio;
					}
				});
			},

			handleLoadCargos() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-cargos', testParms, (resp) => {
					const unorderedCargos = resp.data.table;
					this.cargos = unorderedCargos.sort((a, b) =>
						a.nome_cargo.localeCompare(b.nome_cargo)
					); //order the object alphabetically

					console.log(this.cargos);
				});
			},

			handleLoadLocalDeExames() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
				};

				WBS.send('private-read-local_de_exame', testParms, (resp) => {
					const unorderedLocalDoteste = resp.data.table;
					this.localDoteste = unorderedLocalDoteste.sort((a, b) =>
						a.nome_local_exame.localeCompare(b.nome_local_exame)
					); //order the object alphabetically
				});
			},

			handleLoadEmpresas() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999',
					},
					filter: `regiao='OFF'`,
				};

				WBS.send('private-read-customers', testParms, (resp) => {
					const unorderedEmpresas = resp.data.table;
					this.empresas = unorderedEmpresas.sort((a, b) =>
						a.razao_social.localeCompare(b.razao_social)
					); //order the object alphabetically
				});
			},

			savePassaport() {
				WBS.send('private-save-passaport', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationPassaport();
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});
			},

			saveType() {
				WBS.send('private-save-tipos_de_exame', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationType();
						this.handleLoadTiposDeExames();
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});
			},

			onSelectLocalDeColeta(e) {
				let index = e.target.selectedIndex;

				console.log();

				/*
				id: 1
				estado: "AP"
				municipio: "Amapá"
				nome_local_exame: "NOME"
			*/

				console.log(this.localDoteste[index]);

				let selectedLocal = this.localDoteste[index];

				console.log('==selectedLocal==');
				console.log(selectedLocal);

				console.log('nvsdjnvsjnvjsdnvsdjk');

				this.data.estado = selectedLocal.estado.toUpperCase();
				this.data.municipio = selectedLocal.municipio;
				this.data.nome_local_exame = selectedLocal.nome_local_exame;
			},

			onSelectState() {
				axios
					.get(
						`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.data.estado}/municipios?orderBy=nome`
					)
					.then((response) => (this.municipios = response.data));
			},
		},

		mounted() {
			axios
				.get(
					'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
				)
				.then((response) => (this.estados = response.data));

			this.handleLoadNavios();
			this.handleLoadEmpresas();
			this.handleLoadCargos();
			this.handleLoadLocalDeExames();
		},
	};
</script>

<style>
	span {
		text-transform: uppercase;
	}

	.modal-dialog {
		width: 80% !important;
	}

	.modal-footer__buttons {
		display: flex;
		justify-content: space-between;
	}

	.add-more-section {
		display: flex;
	}
	/*
.table{
	overflow
}
*/

	.md-autocomplete + strong {
		margin-top: 36px;
		display: block;
	}

	.md-autocomplete-items {
		z-index: 99 !important;
		background: white !important;
		position: relative !important;
		top: 85% !important;
	}

	.md-menu-content {
		min-width: 33% !important;
		background: white !important;
		/*
	top: 430px !important;
	*/
		z-index: 99999 !important;
	}

	.md-list {
		width: 100% !important;
		background: white;
		top: 430px !important;
		z-index: 99999;
	}

	.col--featured {
		/*
	*/
		height: 54px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/vacinas/modal.vue